/* src/app/shared/components/app-sidebar/app-sidebar.component.scss */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-thumb {
  background: #acacac;
  border-radius: 8px;
}
::-webkit-scrollbar-track {
}
body {
  scrollbar-face-color: #acacac;
  scrollbar-track-color: rgb(213.5, 213.5, 213.5);
}
:host {
  grid-area: sidebar;
  color: #fafafa;
  display: flex;
  flex-flow: column nowrap;
}
:host .mat-mdc-nav-list {
  padding: 0;
}
:host .mat-mdc-nav-list__open {
  height: auto;
  visibility: visible;
}
@media screen and (min-width: 768px) {
  :host .mat-mdc-nav-list {
    height: 100%;
    visibility: visible;
    max-width: 175px;
    display: flex;
    flex-flow: column nowrap;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
:host .mat-mdc-list-base .mat-icon {
  height: 18px;
  width: 18px;
}
:host .mat-mdc-list-base .mat-mdc-list-item .mdc-list-item__content {
  display: flex;
  justify-content: center;
}
:host .mat-mdc-list-base .mat-mdc-list-item.mat-list-item-with-avatar {
  height: 50px;
}
:host .mat-mdc-list-base .mat-mdc-list-item .nav__chevron-down {
  text-align: end;
  justify-self: flex-end;
}
:host .mat-mdc-list-base .mat-mdc-list-item .nav__chevron-down svg {
  width: 1rem;
  stroke: white;
}
:host .mat-mdc-list-item,
:host .mat-mdc-list-item-icon {
  opacity: 0.9;
  white-space: normal !important;
  line-height: normal;
}
:host .mat-mdc-list-item {
  border-radius: 0 !important;
}
:host .mat-mdc-list-item.disabled {
  opacity: 0.5;
  cursor: default !important;
  text-decoration: none;
}
:host .mat-mdc-list-item.disabled:hover {
  background: transparent !important;
  box-shadow: none;
}
:host .mat-mdc-list-item:hover,
:host .mat-mdc-list-item.active {
  font-weight: bold;
  box-shadow: 3px 0 0 0 white inset;
  background: rgba(255, 255, 255, 0.3) !important;
  letter-spacing: 0.2px;
}
:host .mat-mdc-list-item:hover .mat-mdc-list-item-icon,
:host .mat-mdc-list-item:hover .mat-line,
:host .mat-mdc-list-item.active .mat-mdc-list-item-icon,
:host .mat-mdc-list-item.active .mat-line {
  color: white;
  fill: white;
  opacity: 1;
}
:host .mat-mdc-list-item:hover .mat-line,
:host .mat-mdc-list-item.active .mat-line {
  font-weight: bold;
}
:host .nested-item > * {
  margin-left: 26px;
}
:host .mat-divider {
  border-top-color: rgba(255, 255, 255, 0.12);
}
:host .mat-divider.nav__divider {
  margin-top: 1em;
  margin-bottom: 1em;
}
:host.icon-view {
  align-items: center;
}
:host.icon-view .root-sidebar,
:host.icon-view .app-logo__container {
  width: 100%;
  max-width: none;
  min-height: 50px;
  justify-content: center;
  margin: 0;
  padding: 0;
}
:host.icon-view .logo {
  display: block;
  height: 16px;
  width: auto;
  margin: 0 auto;
}
.icon-view__container {
  width: 50px;
}
.icon-view__list {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.icon-view__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
  text-decoration: none;
}
.icon-view__btn mat-icon {
  width: 24px;
  height: 24px;
  color: #fff;
}
.icon-view__btn mat-icon ::ng-deep svg {
  fill: currentColor;
  color: #fff;
}
.icon-view__btn:hover,
.icon-view__btn.active {
  background: rgba(255, 255, 255, 0.3);
}
.icon-view__btn.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.app-logo__container {
  min-height: 70px;
  max-width: 175px;
  align-items: center;
  justify-content: space-evenly;
  margin: 0 8px;
}
@media screen and (max-width: 767px) {
  .app-logo__container {
    min-height: fit-content;
    justify-content: flex-start;
    margin-left: 0;
  }
}
.logo {
  cursor: pointer;
  height: 16px;
  margin-left: 8px;
}
@media screen and (max-width: 767px) {
  .logo {
    margin: 1em;
  }
}
.nav__toggle-btn-mobile {
  margin: auto 1em;
  margin-right: 0;
}
.nav__toggle-btn-mobile mat-icon {
  line-height: 22px;
}
.nav__toggle-btn {
  color: white;
}
.nav-link {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
/*# sourceMappingURL=app-sidebar.component.css.map */
